export default {"src":"/_next/static/media/card_icon.eb23f685.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};